import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import AllianceIntro from './components/AllianceIntro';
import FactoryShowcase from './components/FactoryShowcase';
import IntegratedSupply from './components/IntegratedSupply';
import QualityControl from './components/QualityControl';
import SupplierCta from './components/SupplierCta';

export default function SupplierNetworkPage() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <AllianceIntro />
        <FactoryShowcase />
        <IntegratedSupply />
        <QualityControl />
        <SupplierCta />
      </main>
      <Footer />
    </div>
  );
}